/**
 * @generated SignedSource<<d5c4fd7ea4f2d7fe8c741747603f0885>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type uploadZone_PollQuery$variables = {
  id: string;
};
export type uploadZone_PollQuery$data = {
  readonly multiUpload: {
    readonly errorMessage: string | null | undefined;
    readonly phase: string | null | undefined;
    readonly state: string;
  } | null | undefined;
};
export type uploadZone_PollQuery = {
  response: uploadZone_PollQuery$data;
  variables: uploadZone_PollQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phase",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uploadZone_PollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MultiUpload",
        "kind": "LinkedField",
        "name": "multiUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uploadZone_PollQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MultiUpload",
        "kind": "LinkedField",
        "name": "multiUpload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b1949f3457066b1a4d7f08a8df5003e9",
    "id": null,
    "metadata": {},
    "name": "uploadZone_PollQuery",
    "operationKind": "query",
    "text": "query uploadZone_PollQuery(\n  $id: ID!\n) {\n  multiUpload(id: $id) {\n    phase\n    state\n    errorMessage\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f52b03df881f4b84ec95ed6706932fa";

export default node;
